import { isSafeInternalPath } from '@common/utils/urls'

export function getNotificationRouteDict(notification) {
  let routeDict = {}

  if (notification.object_delta.primary_order_id) {
    routeDict = {
      pathname: `/orders/${notification.object_delta.primary_order_id}`,
      state: {
        followUpOrder: notification.notification_object_id,
      },
    }
  } else if (notification.notification_object_id) {
    routeDict = {
      pathname: `/orders/${notification.notification_object_id}`,
    }
  }

  // OVERRIDE_PATHNAME comes off the notification's object_delta - API data - so it gets
  // the same internal-path check as every other externally-sourced navigation target
  // before it's allowed to override the default route.
  if (isSafeInternalPath(notification.object_delta.OVERRIDE_PATHNAME)) {
    routeDict = {
      pathname: notification.object_delta.OVERRIDE_PATHNAME,
    }
  }

  return routeDict
}
